export enum Role {
  ADMINISTRATOR = 'ADMINISTRATOR',
  STANDARD_USER = 'STANDARD_USER',
  LIMITED_USER = 'LIMITED_USER',
}
